/*
  Spritz product page behaviour (templates/product.spritz-pdp.json):
  - header video plays only in video mode and never with reduced motion
  - gallery strip arrows and a keyboard/touch friendly lightbox
*/
(function () {
  function initHero(ph) {
    var v = ph.querySelector('.spz-ph-frame video');
    if (!v) return;
    if (ph.dataset.hero !== 'video' || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      v.pause();
      return;
    }
    v.play().catch(function () {});
  }

  function initGallery(root) {
    var items = [].slice.call(root.querySelectorAll('.spz-grail-item'));
    if (!items.length) return;
    var srcs = items.map(function (b) {
      var i = b.querySelector('img');
      return { src: b.dataset.full || i.currentSrc || i.src, alt: i.alt };
    });
    var track = root.querySelector('.spz-grail-track');
    var prev = root.querySelector('.spz-grail-nav.prev');
    var next = root.querySelector('.spz-grail-nav.next');
    function upd() {
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    }
    function step(d) { track.scrollBy({ left: d * track.clientWidth * 0.8, behavior: 'smooth' }); }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();

    var lb = root.querySelector('.spz-lb');
    var img = lb.querySelector('.spz-lb-fig img');
    var cap = lb.querySelector('figcaption');
    var cur = 0;
    var opener = null;
    function show(i) {
      cur = (i + srcs.length) % srcs.length;
      img.src = srcs[cur].src;
      img.alt = srcs[cur].alt;
      cap.textContent = (cur + 1) + ' / ' + srcs.length + (srcs[cur].alt ? '  ·  ' + srcs[cur].alt : '');
    }
    function open(i, from) {
      opener = from || null;
      show(i);
      lb.hidden = false;
      document.body.classList.add('spz-lock');
      lb.querySelector('.spz-lb-close').focus();
    }
    function close() {
      lb.hidden = true;
      document.body.classList.remove('spz-lock');
      if (opener) opener.focus();
    }
    items.forEach(function (b, i) { b.addEventListener('click', function () { open(i, b); }); });
    lb.querySelector('.spz-lb-close').addEventListener('click', close);
    lb.querySelector('.spz-lb-nav.prev').addEventListener('click', function () { show(cur - 1); });
    lb.querySelector('.spz-lb-nav.next').addEventListener('click', function () { show(cur + 1); });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('spz-lb-fig')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(cur - 1);
      else if (e.key === 'ArrowRight') show(cur + 1);
    });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.spz-ph').forEach(initHero);
    (scope || document).querySelectorAll('.spz-grail').forEach(initGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
